import React from 'react'

function NotNote() {
  return (
    <div className='px-3 py-2 bg-red-400 text-white text font-bold flex items-center justify-center rounded-lg'>
      <p>Not notes found this area</p>
    </div>
  )
}

export default NotNote
